import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  const footerBottomStyle = {
    backgroundColor: '#981c1c', // Bottom section color
    color: 'white',
    textAlign: 'center',
    padding: '25px 0', // Increased padding for a larger footer
    marginTop: '20px',
  };

  return (
    <Box component="footer">
      {/* Footer Bottom Section */}
      <Box style={footerBottomStyle}>
        <Typography sx={{ fontSize: '18px' }}> {/* Increased font size */}
          Developed by Gahana Shetty and Pravalik Sagar | © 2024 | Powered by SN Info Systems
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
